import { render, staticRenderFns } from "./areaClienti.vue?vue&type=template&id=06bb96a9&"
import script from "./areaClienti.vue?vue&type=script&lang=js&"
export * from "./areaClienti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports